module.exports = __webpack_public_path__ + "img/image-header-desktop.37a5b4c3.jpg";